import { useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import {
  configApiRef,
  identityApiRef,
  useApi,
} from '@backstage/core-plugin-api';
import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';

export const RequestedByField = ({
  onChange,
  rawErrors,
  required,
  formData,
  schema,
  uiSchema,
}: FieldExtensionComponentProps<string>) => {
  const identityApi = useApi(identityApiRef);
  const configApi = useApi(configApiRef);

  useEffect(() => {
    let mounted = true;

    const loadEmail = async () => {
      try {
        const profile = await identityApi.getProfileInfo();
        let email = profile.email?.trim();

        // The guest sign-in identity used for Playwright E2E runs has no
        // catalog-backed profile, so it never carries an email. Fall back to
        // a fixed placeholder in that mode only (see App.tsx / SPEC.md) so
        // the required field can still be populated.
        if (!email && configApi.getOptionalBoolean('scaffolder.e2eTestMode')) {
          email = 'e2e-test-user@howdengroup.com';
        }

        if (mounted && email && email !== formData) {
          onChange(email);
        }
      } catch {
        // Leave the existing value as-is if identity lookup fails.
      }
    };

    loadEmail();
    return () => {
      mounted = false;
    };
  }, [identityApi, configApi, onChange, formData]);

  const hasError = Boolean(rawErrors?.length);

  return (
    <TextField
      fullWidth
      margin="normal"
      label={schema?.title ?? 'Requested By'}
      required={required}
      error={hasError}
      helperText={
        hasError
          ? rawErrors?.join(', ')
          : (uiSchema?.['ui:help'] as string | undefined) ?? schema?.description
      }
      disabled
      value={formData ?? ''}
    />
  );
};
